__webpack_require__.p = "https://bmidxbswitzerlandfrplprod.netlify.app/";